import { isAbsoluteUrl } from '@portal/utils/util-url';
import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-base-block.styles.scss?module';

interface Events {
  onHeaderClicked: Event;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiBaseBlock',
    props: {
      header: {
        type: String,
        default: ''
      },
      headerClass: {
        type: String,
        default: styles.defaultHeaderColor
      },
      hasBorder: {
        type: Boolean,
        default: true
      },
      url: {
        type: String,
        default: ''
      },
      dataTestHeader: {
        type: String,
        default: ''
      }
    },
    methods: {
      getTargetLink(path: string) {
        return isAbsoluteUrl(path) ? '_blank' : '_self';
      }
    },
    render() {
      const attributes = {
        attrs: this.$attrs
      };

      return (
        <section
          class={[styles.baseBlock, this.hasBorder ? styles.outlined : '']}
          {...attributes}
        >
          {this.header &&
            (this.url ? (
              <a
                href={this.url}
                target={this.getTargetLink(this.url)}
                class={[styles.header, styles.link, this.headerClass]}
                data-test={this.dataTestHeader}
                v-on:click={(event: Event) => this.$emit('headerClicked', event)}
              >
                {this.header}
                <svg class={styles.chevron} width="24" height="24">
                  <use xlinkHref="/dist/legacy/svg-sprites/jtn-critical.42b7545660e4f467e75d4b37a02533e6.svg#jtn-critical-arrow-right"></use>
                </svg>
              </a>
            ) : (
              <div
                class={[styles.header, this.headerClass]}
                data-test={this.dataTestHeader}
                v-on:click={(event: Event) => this.$emit('headerClicked', event)}
              >
                {this.header}
              </div>
            ))}
          <div class={styles.content}>{this.$slots.default}</div>
        </section>
      );
    }
  });
